import { Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

import useService from '@/lib/hooks/useService';
import CommunityDevice from '@/types/database/communityDevice';

import { statusColors } from '../../helpers';
import type { FixSubPage } from '../../types';
import ImageElement from '../UI/ImageElement';
import Info from '../UI/Info';
import {
  ActionBox,
  Card,
  CardWrapper,
  ContentBox,
  HeaderBox,
  Status,
  StyledButton,
} from '../UI/styles';

const FixDetail: FixSubPage = ({ selectedFix, onClose }) => {
  const [devices] = useService<CommunityDevice>({
    collectionName: 'communityDevice',
    query: {
      _id:
        selectedFix.category.name === '公共設備' &&
        selectedFix.category.communityDeviceId,
    },
  });

  const device = devices?.[0];

  return (
    <CardWrapper>
      <Card>
        <HeaderBox>
          <Status $bg={statusColors[selectedFix.status]}>
            {selectedFix.status}
          </Status>
          <Typography
            sx={{
              fontWeight: '500',
              fontSize: '0.9rem',
            }}
          >
            {moment(selectedFix.createdTime).format('YYYY-MM-DD HH:mm')}
          </Typography>
        </HeaderBox>
        <ContentBox>
          <Info label="編號" value={selectedFix.serialNumber} />
          <Info label="戶號" value={selectedFix.householdNumber} />
          <Info label="報修區域" value={selectedFix.category.name} />
          {selectedFix.category.name === '公共設備' && device && (
            <Info label="公共設備" value={device.deviceName} />
          )}
          <Info label="標題" value={selectedFix.title} />
          <Info label="內容" value={selectedFix.content} />
          {selectedFix.image && (
            <Info
              label="圖片"
              value={<ImageElement image={selectedFix.image.path} />}
            />
          )}
          <Info
            label="預約時間"
            value={moment(selectedFix.bookingTime).format('YYYY-MM-DD HH:mm')}
          />
        </ContentBox>
        <ActionBox>
          <StyledButton onClick={onClose}>關閉</StyledButton>
        </ActionBox>
      </Card>
    </CardWrapper>
  );
};

export default FixDetail;
